var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-flex",
    [
      _c(
        "h3",
        { staticClass: "headline", staticStyle: { padding: "15px" } },
        [_c("v-list-item-title", [_vm._v("Filtro reintegri")])],
        1
      ),
      _c("v-divider"),
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-card-title",
            [
              _c(
                "v-flex",
                [
                  _c("v-list-item-title", [_vm._v("Codice distinta:")]),
                  _c(
                    "v-list-item-action",
                    [
                      _c("v-text-field", {
                        attrs: { label: "id distinta" },
                        model: {
                          value: _vm.filtroIdDistinta,
                          callback: function ($$v) {
                            _vm.filtroIdDistinta = $$v
                          },
                          expression: "filtroIdDistinta",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-flex",
                [
                  _c("v-list-item-title", [_vm._v("Da Data Inserimento:")]),
                  _c(
                    "v-list-item-action",
                    [
                      _c(
                        "v-menu",
                        {
                          ref: "menu1",
                          attrs: {
                            "offset-y": "",
                            transition: "scale-transition",
                            "max-width": "290px",
                            "min-width": "90px",
                            "close-on-content-click": false,
                            "nudge-right": 40,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  _c(
                                    "v-text-field",
                                    _vm._g(
                                      {
                                        attrs: {
                                          clearable: "",
                                          label: "da data",
                                          "persistent-hint": "",
                                          "prepend-icon": "mdi-calendar",
                                        },
                                        on: {
                                          blur: function ($event) {
                                            _vm.filtroDataInserimentoDa =
                                              _vm.parseDate(
                                                _vm.filtroDataInserimentoDaFormatted
                                              )
                                          },
                                        },
                                        model: {
                                          value:
                                            _vm.filtroDataInserimentoDaFormatted,
                                          callback: function ($$v) {
                                            _vm.filtroDataInserimentoDaFormatted =
                                              $$v
                                          },
                                          expression:
                                            "filtroDataInserimentoDaFormatted",
                                        },
                                      },
                                      on
                                    )
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.menu1,
                            callback: function ($$v) {
                              _vm.menu1 = $$v
                            },
                            expression: "menu1",
                          },
                        },
                        [
                          _c("v-date-picker", {
                            on: {
                              input: function ($event) {
                                _vm.menu1 = false
                              },
                            },
                            model: {
                              value: _vm.filtroDataInserimentoDa,
                              callback: function ($$v) {
                                _vm.filtroDataInserimentoDa = $$v
                              },
                              expression: "filtroDataInserimentoDa",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-list-item-title", [_vm._v("A Data Inserimento:")]),
                  _c(
                    "v-list-item-action",
                    [
                      _c(
                        "v-menu",
                        {
                          ref: "menu2",
                          attrs: {
                            "offset-y": "",
                            transition: "scale-transition",
                            "max-width": "290px",
                            "min-width": "90px",
                            "close-on-content-click": false,
                            "nudge-right": 40,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  _c(
                                    "v-text-field",
                                    _vm._g(
                                      {
                                        attrs: {
                                          clearable: "",
                                          label: "a data",
                                          "persistent-hint": "",
                                          "prepend-icon": "mdi-calendar",
                                        },
                                        on: {
                                          blur: function ($event) {
                                            _vm.filtroDataInserimentoA =
                                              _vm.parseDate(
                                                _vm.filtroDataInserimentoAFormatted
                                              )
                                          },
                                        },
                                        model: {
                                          value:
                                            _vm.filtroDataInserimentoAFormatted,
                                          callback: function ($$v) {
                                            _vm.filtroDataInserimentoAFormatted =
                                              $$v
                                          },
                                          expression:
                                            "filtroDataInserimentoAFormatted",
                                        },
                                      },
                                      on
                                    )
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.menu2,
                            callback: function ($$v) {
                              _vm.menu2 = $$v
                            },
                            expression: "menu2",
                          },
                        },
                        [
                          _c("v-date-picker", {
                            on: {
                              input: function ($event) {
                                _vm.menu2 = false
                              },
                            },
                            model: {
                              value: _vm.filtroDataInserimentoA,
                              callback: function ($$v) {
                                _vm.filtroDataInserimentoA = $$v
                              },
                              expression: "filtroDataInserimentoA",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-list-item-action"),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c(
                "v-btn",
                { attrs: { text: "" }, on: { click: _vm.svuotaFiltro } },
                [_vm._v("Svuota")]
              ),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { text: "" },
                  on: { click: _vm.annullaModificaFiltro },
                },
                [_vm._v("Annulla")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { text: "", color: "primary" },
                  on: { click: _vm.applicaModificaFiltro },
                },
                [_vm._v("Applica")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }